/* eslint-disable require-yield,no-console,no-undef */
import { put, takeEvery } from 'redux-saga/effects';

function* progressE(action) {
    let { data } = action.payload;
    try {
        yield put({ type: 'ADD_MSG_LIST_CHAT', payload: data });
        yield put({ type: 'SOUND_NEW_MSG', payload: true });
    } catch (e) {
        yield put({ type: 'ERROR', message: e.message });
    }
}

function* SagaStaffSendChat() {
    yield takeEvery('STAFF_SEND_CHAT', progressE);
}


export default SagaStaffSendChat;



// WEBPACK FOOTER //
// ./src/redux/saga/actions/SagaStaffSendChat.js